module.exports = "<svg id=\"cb11e8fd-8dab-44fd-89ea-2da075c4c66d\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>phone</title><path d=\"M15.29,31.72,6.87,42.38a.56.56,0,0,0,.09.79H7l6.42,5.14A6.28,6.28,0,0,0,18,49.66c1.59-.17,12.42-13.18,15.84-19.12a126.71,126.71,0,0,0,8.77-18.49A6.3,6.3,0,0,0,39,4L31.32,1a.56.56,0,0,0-.73.32h0l-5,12.64a.56.56,0,0,0,.32.73h0l4.29,1.67c-1.45,3.13-3.07,6.25-4.83,9.3l0,0c-1.75,3-3.64,6-5.62,8.8L16.11,31.6a.57.57,0,0,0-.79.09l0,0ZM31.44,16.29h0Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Phone.svg
// module id = /VDe
// module chunks = 1